// src/javascript/utils/showScoreRequirementDialog.js
import ScoreManager from './ScoreManager.js'

export default function showScoreRequirementDialog(minPoints = 5) {
    const currentScore = ScoreManager.get()
    if (currentScore >= minPoints) {
        return true // Score ausreichend
    }

    const container = document.querySelector('.js-dialog-fail')
    if (!container) return false

    const messages = [...container.querySelectorAll('.js-message')]
    container.classList.remove('is-hover-no', 'is-hover-yes')
    container.classList.add('is-hover-none', 'is-active')

    // Reset
    messages.forEach(msg => msg.classList.remove('is-visible'))

    let step = 0
    const showStep = () => {
        if (step >= messages.length) return

        const current = messages[step]
        current.classList.add('is-visible')

        // Abstand zwischen den Nachrichten (nach oben verschieben)
        let offset = 0
        for (let i = 0; i <= step; i++) {
            const el = messages[i]
            el.style.transform = `translateY(${-offset}px)`
            offset += el.offsetHeight - 25
        }

        step++
        if (step < messages.length) {
            setTimeout(showStep, 1800)
        }
    }

    // Start Anzeige
    showStep()

    // Automatisch wieder ausblenden
    setTimeout(() => {
        messages.forEach(msg => msg.classList.remove('is-visible'))
        container.classList.remove('is-active')
    }, 6000)

    return false // Score war nicht ausreichend
}
